'use client';

import { useSplitWizard } from '../../model/split-wizard-context';
import { StepEmailSplit } from '../steps/step-email-split';
import { StepProfileSplit } from '../steps/step-profile/step-profile-split';


export const StartStepSwitch = () => {
    const { state } = useSplitWizard();

    switch (state.step) {
        case 'email':
            return <StepEmailSplit/>;

        case 'profile':
            return <StepProfileSplit/>;

        default:
            return null;
    }
};
